export enum OnrampType {
    ONRAMP = "onramp",
    ONRAMP_AND_WITHDRAW = "onramp_and_withdraw",
}